

























import Vue from 'vue';
import { ComponentVersionService } from '../services/ComponentVersionService';
import { ComponentVersionModel, ThirdPartyComponentVersionModel } from '../types';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';

export default Vue.extend({
  name: 'AboutPage',
  data() {
    return {
      componentVersions: [] as ComponentVersionModel[],
      thirdPartyComponentVersions: [
        {
          componentName: 'Dapper',
          versionNumber: '2.0.123',
          license: {
            licenseText: 'Apache 2.0',
            licenseLink: 'http://www.apache.org/licenses/LICENSE-2.0'
          }
        }
      ] as ThirdPartyComponentVersionModel[]
    };
  },
  methods: {
    async getVersions() {
      const versions = (await ComponentVersionService.getComponentVersions()) as ComponentVersionModel[];
      versions.forEach((x) => {
        const versionDate = new Date(x.versionDate);
        x.versionDate = versionDate.valueOf() ? versionDate.toLocaleDateString() : '';
      });
      this.componentVersions = versions.sort((a, b) => a.componentName.localeCompare(b.componentName));
    }
  },
  mounted() {
    this.getVersions();
  },
  components: {
    LoadingSpinner
  }
});
